import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import "../Certificaciones/Certificaciones.css";
import Footer from "../Footer";
import "../Certificaciones/Card_certificaciones.css";
import banner from "../../images/asesorias.jpg";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from "../../app/models/CATCursos";
import { RegionalBannerPeten } from '../Portafolio/Handlers/RegionalBannerPeten';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";

const loadImage = (imageName: any) =>
  require(`../../images/${imageName}`).default;
export default observer(function Asesoria() {
  const {
    userStore: {  },
  } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByDir("21");
    }
  }, [CATCursosRegistry.size, loadCATCursosByDir]);
  
  
  if (CATCursosStore.loadingInitial)
  return <LoadingComponent content="Cargando datos.." />;
  return (
    
    
    <div className="contenedor_certificaciones_pagina">
      <RegionalBannerPeten />
      <AnchorTabsCategories />
      <img src={banner} alt="imagen" style={{ width: "100%" }}></img>
      <div style={{ maxWidth: "1324px", margin: "auto" }}>
        <div className="contenedor_descripcion">
          <p className="parrafo_certificaciones">
            El punto de partida de la gestión por resultados de una institución
            pública es el conocimiento de su realidad a nivel estratégico,
            táctico y operativo. A este conocimiento se llega mediante
            herramientas y procedimientos de investigación sistemáticos que se
            aplican con el propósito de entender los factores de satisfacción o
            insatisfacción en el desempeño institucional. Es por ello que, el
            INAP ofrece asesoría y asistencia técnica a otras instituciones
            públicas en el marco de su competencia. Además, desarrolla
            investigaciones aplicadas con el objetivo de fortalecer la
            Administración Pública. Las cuales podrán ser solicitadas a demanda
            por cada una de las instituciones.
          </p>
        </div>
        <div className="contenedor_cartas">
          <div className="contenedorI">
            <iframe
              className="mi-iframe"
              src={"https://inap.gob.gt/web/asesorias-y-asistencia-tecnia/"}
              allowFullScreen
            ></iframe>
            {/* {CATCursosStore.getCATCursosByCodigo.map((item: getCATCursos) => {
              
            })} */}
          </div>
        </div>
      </div>
      <br></br>
      <Footer />
    </div>
  );
});
